import { IAct, TProfile } from '@newo/api/gateway';

const LABEL_PAD = 22;
const formatLine = (label: string, value?: string | number | null) =>
    label.padEnd(LABEL_PAD) + (value ?? 'N/A');

export const buildConversationUrl = (sessionId?: string | null): string => {
    const currentUrl = globalThis.location.href;
    if (!sessionId) return currentUrl;

    try {
        const url = new URL(currentUrl);
        if (!url.searchParams.has('session_id')) {
            url.searchParams.set('session_id', sessionId);
            return url.toString();
        }
    } catch (err) {
        console.error('Error parsing URL:', err);
    }

    return currentUrl;
};

export const generateReport = (act: IAct, profile: TProfile) => {
    const conversationUrl = buildConversationUrl(act?.session_id);
    return [
        formatLine('Organization Name:', profile?.organization_name),
        formatLine('Customer Idn:', profile?.idn),
        formatLine('Project Idn:', act?.project_idn),
        formatLine('External Event Id:', act?.external_event_id),
        formatLine('Runtime Context ID:', act?.runtime_context_id),
        formatLine('User Persona Id:', act?.user_persona_id),
        formatLine('Agent Persona Id:', act?.agent_persona_id),
        formatLine('Session Id:', act?.session_id),
        formatLine('Conversation URL:', conversationUrl),
        formatLine('Message:', act?.original_text)
    ].join('\n');
};
